import cx from 'classnames';
import styles from 'styles/shop/product.module.css';
import { useLanguageLoader } from 'contexts/language';
import Quantity from 'components/quantity/Quantity';
import { useProduct } from 'components/products/context';
import { useField } from 'formik';
import _ from 'ui/lodash';
import Select from 'phoenix-components/lib/Select';
import { useMemo } from 'react';
import { ReactInput } from 'phoenix-components';

export function QuantityBox() {
  const product = useProduct();
  const lang = useLanguageLoader();
  const [{ value: quantity }, , { setValue: setQuantity }] = useField('quantity');

  const quantitySchema = product?.quantity ?? {};
  const showQuantity = quantitySchema.type === 'finite' && quantitySchema.maxQuantity <= 10;
  const showSelectDropDown = quantitySchema.type === 'finite' && quantitySchema.maxQuantity > 10;
  const isInfinite = quantitySchema.type === 'infinite';
  const min = quantitySchema.minQuantity || 0;
  const max = (quantitySchema.maxQuantity || 0) + min;
  const step = quantitySchema.group || 0;

  const options = useMemo(() => {
    return _.range(min, max, step)
      .map((q) => ({
        value: q,
        label: q,
      }));
  }, [min, max, step]);

  const selectedQuantity = options?.find(x => x.value === quantity);

  return (
    <>
      <div className={(cx(styles.key, styles.noBorder))}>
        {lang('store.words.quantity')}
      </div>
      {showQuantity && (
        <Quantity
          item={product}
          count={quantity}
          update={setQuantity}
          redirect={false}
        />
      )}

      {showSelectDropDown && (
        <Select
          title={lang('store.words.selectGroup')}
          value={selectedQuantity}
          onChange={(e) => setQuantity(e.value)}
          options={options}
          className={styles.customSelect}
        />
      )}
      {isInfinite && (
        <ReactInput
          label={lang('store.words.enterQuantity')}
          placeholder={lang('store.words.enterQuantity')}
          setValue={(e) => {
            setQuantity(e);
          }}
          value={quantity}
        />
      )}
      {product?.quantity?.type === "finite" && product?.quantity?.maxQuantity >= 1 && (
        <div className={styles.help}>
          {lang('store.words.maxQuantity')}: {product?.quantity?.maxQuantity}
        </div>
      )}
    </>
  );
}
